import React, { FunctionComponent } from 'react'
import { Icon } from '@/icons'
import { Popup } from '@/components/Popup'
import { Button } from '@/components/Button'

import styles from './ConfirmationPopup.module.scss'

interface ConfirmationPropsProps {
  onClose: () => void
  data: {
    title?: string
    description?: string
    button?: string
  }
}
export const ConfirmationPopup: FunctionComponent<ConfirmationPropsProps> = ({
  onClose,
  data,
}) => {
  return (
    <Popup onClose={onClose}>
      <div className={styles.container}>
        <div className={styles.header}>
          <Icon name="approved" width={72} height={72} />
          <div
            className={styles.title}
            dangerouslySetInnerHTML={{ __html: data.title }}
          />
        </div>
        {data.description ? (
          <div
            className={styles.description}
            dangerouslySetInnerHTML={{ __html: data.description }}
          />
        ) : null}
        {data.button ? (
          <Button
            className={styles.button}
            name={data.button}
            onClick={onClose}
          />
        ) : null}
      </div>
    </Popup>
  )
}
